<div class="container-navs">
    <ul class="nav nav-tabs">
        <li *ngFor="let perspectiva of perspectivas; let isFirst = first" class="nav-item">
            <a class="nav-link"
                [class.active]="isFirst"
                attr.data-target="#tabPerspectiva_{{perspectiva.id}}"
                data-toggle="tab"
                (click)="onTabClick(perspectiva)">
                {{perspectiva.nome}}
            </a>
        </li>                                                                                                                                                                                                                                  
    </ul>
    <div class="tab-content">       
        <div *ngFor="let perspectiva of perspectivas; let isFirst = first"
            class="tab-pane"
            [class.active]="isFirst"
            id="tabPerspectiva_{{perspectiva.id}}">
            <sgt-curva-abc-venda-perspectiva-content
                #perspectivaContent
                [perspectiva]="perspectiva"
                [filter]="filter"
                [filterStorageKey]="filterStorageKey">
            </sgt-curva-abc-venda-perspectiva-content>
        </div>
    </div>
</div>